import { render, staticRenderFns } from "./ColumnSector.vue?vue&type=template&id=c23dd2f0"
import script from "./ColumnSector.vue?vue&type=script&lang=js"
export * from "./ColumnSector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c23dd2f0')) {
      api.createRecord('c23dd2f0', component.options)
    } else {
      api.reload('c23dd2f0', component.options)
    }
    module.hot.accept("./ColumnSector.vue?vue&type=template&id=c23dd2f0", function () {
      api.rerender('c23dd2f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Documents/Conferences/Columns/ColumnSector.vue"
export default component.exports